import { filterConstants } from '../constants/index'

export const filterAction = filter => {
    return { type: filterConstants.FILTER_ACTION, filter: filter }
} // je garde le export ici car deja utiliser on changera en temps voulu
